import { defineMessages } from 'react-intl';

export default defineMessages({
  location: {
    id: 'filters.location',
    defaultMessage: 'Location',
  },
  date: {
    id: 'filters.date',
    defaultMessage: 'Date',
  },
  guests: {
    id: 'filters.guests',
    defaultMessage: 'Guests',
  },
  activities: {
    id: 'filters.activities',
    defaultMessage: 'Activities',
  },
  search: {
    id: 'filters.search',
    defaultMessage: 'Search',
  },
});
